import { Injectable } from '@angular/core';
import {AbstractFindOneByIdService} from '../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {MedicalMorphologyModel} from '../model/medicalMorphology.model';
import {MedicalMorphologyRepository} from '../../impl/service/ngrx/medicalMorphology.repository';
import {MedicalMorphologyDataServiceAdapter} from '../../impl/service/ngrx/medicalMorphologyDataService.adapter';

@Injectable()
export class MedicalMorphologyFindOneByIdService extends AbstractFindOneByIdService<MedicalMorphologyModel, MedicalMorphologyModel> {

    constructor(repository: MedicalMorphologyRepository, dataServiceAdapter: MedicalMorphologyDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
